import Tickets from "../tickets/[username]";

export { getStaticProps, getStaticPaths } from "../tickets/[username]";
export default Tickets;
